module.exports = __webpack_public_path__ + "media/images/gallery/en_tab_on-46c2cdeffaf7c54e751da2b47a142a87.jpg";